const convertUnicodeEmoji = item => {
    if(item){
        let msg = item;
        try {
          msg.replace(/^[a-záàâãéèêíïóôõöúçñ ]+$/i);
          msg = msg.replace(/\n|\r\n/gi, "¿");
          msg = msg.replace(/"/gi, "'");
          msg = msg.replace(/\\\\n/gi, "\r\n");
          msg = msg.replace(/"/gi, "'");
          msg = msg.replace(/"/gm, '\\"');
          if (msg) {
            var mensagem_tratada = msg.replace(/\n|\r\n/gi, "¿");
            // var mensagem_tratada = msg.replace(/¿/gi, "\n");
            // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
            // mensagem_tratada = mensagem_tratada.replace(/\n/gi, "\\n");
            let valor = 1;
            try {
              mensagem_tratada =
                '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
              var obj = JSON.parse(mensagem_tratada);
              mensagem_tratada = obj[1][0].mensagem_tratada;
            } catch (e) {
              mensagem_tratada = item;
            }
            mensagem_tratada = mensagem_tratada.replace(/¿/gi, "\n");
            return mensagem_tratada;
          }
        } catch (error) {
          // console.log("TRY CATCH")     
          // ERROR 
        }
        return msg;
      }
      return item
}

export default convertUnicodeEmoji;


// backup versao antiga
// const convertUnicodeEmoji = item => {
//     if(item){
//         var mensagem_tratada = item.replace(/¿/gi, "\n");
//         mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
//         let valor = 1
//         try{
//         mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
//         var obj = JSON.parse(mensagem_tratada);
//         mensagem_tratada = obj[1][0].mensagem_tratada
//         } catch(e){
//             mensagem_tratada = item; 
//         }
//         return mensagem_tratada
//     } 
//     return ""
// }

// export default convertUnicodeEmoji;